import React from "react"
import cx from "classnames"
import Button from "components/common/Button"
import FormInput from "components/form/input"
import FormDropdown from "components/form/dropdown"
import FormDatePicker from "components/form/datepicker"
import Panel from "components/panel"
import Text from "components/text"
import CheckBox from "components/checkbox"
import { isEmpty } from "lodash"
import StatementModal from "components/common/StatementModal"
import "./index.scss"

const REQUIRED_FIELDS = [
  "roll_number",
  "ibp_chapter",
  "law_school",
  "company",
  "position",
  "address",
  "region",
  "province",
  "city",
  "zip_code",
]

const REQUIRED_FIELDS_NO_MCLE = [
  "company",
  "position",
  "address",
  "region",
  "province",
  "city",
  "zip_code",
]
class MCLEProfile extends React.Component {
  selectRefs = {
    ibp_chapter: React.createRef(),
    law_school: React.createRef(),
    region: React.createRef(),
    province: React.createRef(),
    city: React.createRef(),
    civil_status: React.createRef(),
  }

  constructor(props) {
    super(props)

    this.state = {
      mcleProfile: {
        roll_number: "",
        ibp_chapter: "",
        ibp_lifetime_no: "",
        ibp_or_number: "",
        license_number: "",
        ibp_or_date: "",
        year_admitted: "",
        law_school: "",
        law_school_others: "",
        company: "",
        position: "",
        address: "",
        region: "",
        province: "",
        city: "",
        zip_code: "",
        home_address: "",
        work_address: "",
        telephone_number: "",
        fax_number: "",
        birth_place: "",
        civil_status: "",
      },
      homeSameAsMailingAddress: false,
      workSameAsMailingAddress: false,
      formErrors: {},
      regions: [],
      provinces: [],
      cities: [],
      zipCodes: [],
    }
  }

  async componentDidMount() {
    const { mcleProfile, phRegions } = this.props
    let regions = []

    phRegions.forEach((region) => {
      regions.push({
        key: region.value,
        value: region.value,
        label: region.region,
      })
    })

    await this.handleChangeRegion({ value: mcleProfile.region })
    await this.handleChangeProvince({ value: mcleProfile.province })
    await this.handleChangeCity({ value: mcleProfile.city })

    await this.setState({ regions, mcleProfile })
  }

  async componentDidUpdate(prevProps) {
    const { mcleProfile: prevMcleProfile } = prevProps
    const { mcleProfile } = this.props

    if (mcleProfile && prevMcleProfile !== mcleProfile) {
      await this.setState({
        mcleProfile,
      })

      await this.handleChangeRegion({ value: mcleProfile.region })
      await this.handleChangeProvince({ value: mcleProfile.province })
      await this.handleChangeCity({ value: mcleProfile.city })
    }
  }

  handleChange = (e) => {
    const { mcleProfile } = this.state
    const { name, value } = e.currentTarget

    this.setState(
      {
        mcleProfile: {
          ...mcleProfile,
          [name]: value,
        },
      },
      () => {
        this.validateForm(name)

        if (name === "address") {
          this.updateMailingAddress()
        }
      }
    )
  }

  handleChangeDate = (date) => {
    const { mcleProfile } = this.state
    this.setState(
      {
        mcleProfile: {
          ...mcleProfile,
          ibp_or_date: date,
        },
      },
      () => {
        this.validateForm("ibp_or_date")
      }
    )
  }

  handleSelect = (data) => {
    const { mcleProfile } = this.state
    const { name, value } = data

    this.setState(
      {
        mcleProfile: {
          ...mcleProfile,
          [name]: value,
        },
      },
      () => {
        this.validateForm(name)
      }
    )
  }

  handleChangeRegion = async (data) => {
    const { mcleProfile } = this.state
    const { phRegions } = this.props
    const { value } = data

    if (value !== "") {
      const currentRegion = phRegions.filter((item) => item.value === value)

      if (
        currentRegion.length > 0 &&
        currentRegion[0].value !== mcleProfile.region
      ) {
        let provinces = currentRegion[0]["provinces"].map((province) => {
          return {
            key: province.value,
            label: province.name,
            ...province,
          }
        })

        await this.setState({
          mcleProfile: {
            ...mcleProfile,
            region: value,
            province: "",
            city: "",
            zip_code: "",
          },
          provinces: provinces,
          cities: [],
          zipCodes: [],
        })
      }
    } else {
      await this.setState({
        mcleProfile: {
          ...mcleProfile,
          region: "",
          province: "",
          city: "",
          zip_code: "",
        },
        provinces: [],
        cities: [],
        zipCodes: [],
      })
    }

    this.validateForm("region")
    this.updateMailingAddress()
  }

  handleChangeProvince = async (data) => {
    const { mcleProfile, provinces = [] } = this.state
    const { value } = data

    if (value !== "") {
      const currentProvince = provinces.filter((item) => item.key === value)

      if (
        currentProvince.length > 0 &&
        currentProvince[0].value !== mcleProfile.province
      ) {
        let cities = currentProvince[0]["cities"].map((city) => {
          return {
            key: city.name,
            label: city.name,
            value: city.name,
            ...city,
          }
        })

        await this.setState({
          mcleProfile: {
            ...mcleProfile,
            province: value,
            city: "",
            zip_code: "",
          },
          cities: cities,
          zipCodes: [],
        })
      }
    } else {
      await this.setState({
        mcleProfile: {
          ...mcleProfile,
          province: "",
          city: "",
          zip_code: "",
        },
        cities: [],
        zipCodes: [],
      })
    }

    this.validateForm("province")
    this.updateMailingAddress()
  }

  handleChangeCity = async (data) => {
    const { mcleProfile, cities = [] } = this.state
    const { value } = data

    if (value !== "") {
      const currentCity = cities.filter((item) => item.key === value)

      if (currentCity.length > 0 && currentCity[0].value !== mcleProfile.city) {
        let zips = currentCity[0]["zips"].map((zip, index) => {
          return {
            key: index,
            label: `${zip.code} - ${zip.name}`,
            value: zip.code,
            ...zip,
          }
        })

        await this.setState({
          mcleProfile: {
            ...mcleProfile,
            city: value,
            zip_code: "",
          },
          zipCodes: zips,
        })
      }
    } else {
      await this.setState({
        mcleProfile: {
          ...mcleProfile,
          city: "",
          zip_code: "",
        },
        zipCodes: [],
      })
    }

    this.validateForm("city")
    this.updateMailingAddress()
  }

  handleChangeZip = async (data) => {
    const { mcleProfile, zipCodes = [] } = this.state
    const { value } = data

    if (value !== "") {
      const currentZip = zipCodes.filter((item) => item.value === value)

      if (currentZip.length > 0) {
        await this.setState({
          mcleProfile: {
            ...mcleProfile,
            zip_code: value,
          },
        })
      }
    } else {
      await this.setState({
        mcleProfile: {
          ...mcleProfile,
          zip_code: "",
        },
      })
    }

    this.validateForm("zip_code")
    this.updateMailingAddress()
  }

  validateForm = (fieldName) => {
    let formErrors = this.state.formErrors

    if (!isEmpty(formErrors[fieldName])) {
      delete formErrors[fieldName]
    }

    this.setState({ formErrors })
  }

  validateFormOnSubmit() {
    const { mcleProfile } = this.state
    const { isMCLENA } = this.props
    const error = {}

    if (isMCLENA) {
      REQUIRED_FIELDS_NO_MCLE.forEach((fieldName) => {
        if (isEmpty(mcleProfile[fieldName] + "")) {
          error[fieldName] = "This field is required"
        }
      })
    } else {
      REQUIRED_FIELDS.forEach((fieldName) => {
        if (isEmpty(mcleProfile[fieldName] + "")) {
          error[fieldName] = "This field is required"
        }
      })
    }

    if (mcleProfile.law_school === "others") {
      if (isEmpty(mcleProfile.law_school_others)) {
        error["law_school_others"] = "This field is required"
      }
    } else {
      this.setState({
        mcleProfile: {
          ...mcleProfile,
          law_school_others: "",
        },
      })
    }

    if (!isEmpty(error)) {
      this.setState({
        formErrors: error,
      })

      for (let fieldName in error) {
        if (this.selectRefs[fieldName]) {
          let field = this.selectRefs[fieldName]
          field.current.focus()
        } else {
          let field = document.getElementsByName(fieldName)
          if (field.length > 0) {
            field[0].focus()
          }
        }
        break
      }
    } else {
      this.statementModalToggle()
    }
  }

  statementModalToggle = () => {
    this.setState((prevState) => ({
      showStatementModal: !prevState.showStatementModal,
    }))
  }

  toggleCopyMailingAddress = (target) => {
    const {
      homeSameAsMailingAddress,
      workSameAsMailingAddress,
      mcleProfile = {},
    } = this.state

    const { home_address, work_address } = mcleProfile

    if (target === "home") {
      let mailingAddress = this.getMailingAddress()

      this.setState({
        homeSameAsMailingAddress: !homeSameAsMailingAddress,
        mcleProfile: {
          ...mcleProfile,
          home_address: !homeSameAsMailingAddress
            ? mailingAddress
            : home_address,
        },
      })
    } else if (target === "work") {
      let mailingAddress = this.getMailingAddress()

      this.setState({
        workSameAsMailingAddress: !workSameAsMailingAddress,
        mcleProfile: {
          ...mcleProfile,
          work_address: !workSameAsMailingAddress
            ? mailingAddress
            : work_address,
        },
      })
    }
  }

  getMailingAddress = () => {
    const {
      mcleProfile = {},
      regions = [],
      provinces = [],
      cities = [],
      zipCodes = [],
    } = this.state

    const {
      address = "",
      region = "",
      province = "",
      city = "",
      zip_code = "",
    } = mcleProfile

    let regionText = regions.find((option) => option.value === region)?.label
    let provinceText = provinces.find(
      (option) => option.value === province
    )?.label
    let cityText = cities.find((option) => option.value === city)?.label
    let zipCodeText = zipCodes.find(
      (option) => option.value === zip_code
    )?.value

    let mailingAddress = [
      address,
      cityText,
      provinceText,
      regionText,
      zipCodeText,
    ]
      .filter((item) => item && item !== "")
      .join(", ")

    return mailingAddress
  }

  updateMailingAddress = () => {
    const {
      homeSameAsMailingAddress,
      workSameAsMailingAddress,
      mcleProfile = {},
    } = this.state

    const { home_address, work_address } = mcleProfile

    let mailingAddress = this.getMailingAddress()

    this.setState({
      mcleProfile: {
        ...mcleProfile,
        home_address: homeSameAsMailingAddress ? mailingAddress : home_address,
        work_address: workSameAsMailingAddress ? mailingAddress : work_address,
      },
    })
  }

  handleSaveMCLE = () => {
    const { handleSave, isMCLENA } = this.props
    const { mcleProfile } = this.state
    let payload = {}
    if (isMCLENA) {
      payload = {
        ...mcleProfile,
        roll_number: "",
        ibp_chapter: "",
        ibp_lifetime_no: "",
        ibp_or_number: "",
        license_number: "",
        ibp_or_date: "",
        year_admitted: "",
        law_school: "",
        law_school_others: "",
      }
    } else {
      payload = {
        ...mcleProfile,
      }
    }
    handleSave(payload)
  }

  render() {
    const {
      loading,
      lawSchools = [],
      schoolData = {},
      ibpChapters,
      phRegions,
      isMCLENA,
      toggleMCLEApplicable,
    } = this.props

    const {
      mcleProfile = {},
      formErrors = {},
      showStatementModal,
      provinces = [],
      cities = [],
      zipCodes = [],
      homeSameAsMailingAddress,
      workSameAsMailingAddress,
    } = this.state

    const lawSchoolOptions = lawSchools.map((school) => {
      return {
        key: school.id,
        value: school.id,
        label: school.name,
      }
    })

    lawSchoolOptions.push({
      key: "others",
      value: "others",
      label: "Others",
    })

    const otherLawSchool = mcleProfile.law_school === "others" ? true : false
    const lawSchool =
      mcleProfile?.law_school && mcleProfile?.law_school !== "others"
        ? parseFloat(mcleProfile?.law_school)
        : mcleProfile?.law_school

    const regions = phRegions.map((region) => {
      return {
        key: region.value,
        value: region.value,
        label: region.region,
      }
    })

    const civilStatus = [
      { key: "single", value: "Single", label: "Single" },
      { key: "married", value: "Married", label: "Married" },
      { key: "widowed", value: "Widowed", label: "Widowed" },
    ]

    return (
      <>
        <Panel pad="24">
          <div className="note-container">
            <span className="icon-success">
              <i className="fas fa-exclamation-circle fa-3x"></i>
            </span>
            <p>
              The information provided here will be used to pre-fill
              Certificates of Attendance, MCLE Form 3 or the Attorney's MCLE
              Compliance Report, and other similar documents/forms. Please
              provide accurate and complete information.
              <br />
              <br />
              If you do not provide an answer for all the items, the pertinent
              information will not appear in your MCLE Form 3 / AMCR. As a
              consequence, you will have to manually fill up those parts later.
            </p>
          </div>
        </Panel>
        <div className="mcle-profile">
          <Panel pad="40">
            <Text type="headline" text="MCLE Profile" />
            <CheckBox
              text="Not applicable"
              value={isMCLENA}
              checked={isMCLENA}
              onChange={toggleMCLEApplicable}
              id="chk-mcle-na"
            />
            {!isMCLENA && (
              <>
                <FormInput
                  type="number"
                  label="Roll Number"
                  name="roll_number"
                  value={mcleProfile.roll_number}
                  error={formErrors.roll_number}
                  handleChange={this.handleChange}
                  required={isMCLENA ? false : true}
                />
                <FormInput
                  type="number"
                  label="Lifetime Membership No."
                  name="ibp_lifetime_no"
                  value={mcleProfile.ibp_lifetime_no}
                  error={formErrors.ibp_lifetime_no}
                  handleChange={this.handleChange}
                />
                <FormDropdown
                  label="IBP Chapter"
                  name="ibp_chapter"
                  optionGroups={ibpChapters}
                  value={mcleProfile.ibp_chapter}
                  error={formErrors.ibp_chapter}
                  handleChange={this.handleSelect}
                  required={isMCLENA ? false : true}
                  fieldRef={this.selectRefs.ibp_chapter}
                />
                <FormInput
                  type="number"
                  label="IBP O.R. Number"
                  name="ibp_or_number"
                  value={mcleProfile.ibp_or_number}
                  error={formErrors.ibp_or_number}
                  handleChange={this.handleChange}
                />
                <FormDatePicker
                  label="IBP O.R. Date"
                  name="ibp_or_date"
                  value={mcleProfile.ibp_or_date}
                  error={formErrors.ibp_or_date}
                  handleChangeDate={this.handleChangeDate}
                />

                <FormInput
                  type="number"
                  label="Year Admitted to the Bar"
                  name="year_admitted"
                  value={mcleProfile.year_admitted}
                  error={formErrors.year_admitted}
                  handleChange={this.handleChange}
                />

                <div className={cx("columns", !otherLawSchool && "-full")}>
                  <FormDropdown
                    label="Law School Graduate From"
                    name="law_school"
                    options={lawSchoolOptions}
                    value={lawSchool}
                    error={formErrors.law_school}
                    handleChange={this.handleSelect}
                    required={isMCLENA ? false : true}
                    fieldRef={this.selectRefs.law_school}
                  />
                </div>
                {otherLawSchool && (
                  <FormInput
                    label="Other Law School"
                    name="law_school_others"
                    value={mcleProfile.law_school_others}
                    error={formErrors.law_school_others}
                    handleChange={this.handleChange}
                    required={otherLawSchool}
                  />
                )}
              </>
            )}

            <div className="grid-section">Employment Details</div>
            <FormInput
              type="text"
              label="Company/Firm"
              name="company"
              value={mcleProfile.company}
              error={formErrors.company}
              handleChange={this.handleChange}
              required={true}
            />
            <FormInput
              type="text"
              label="Position"
              name="position"
              value={mcleProfile.position}
              error={formErrors.position}
              handleChange={this.handleChange}
              required={true}
            />
            <div className="grid-section">Address</div>
            <FormInput
              type="text"
              label="Preferred Mailing Address"
              name="address"
              value={mcleProfile.address}
              error={formErrors.address}
              handleChange={this.handleChange}
              required={true}
              labelFor="Unit Number, Building Name, Name of Compound, Street Name"
            />
            <FormDropdown
              type="text"
              label="Region"
              name="region"
              value={mcleProfile.region}
              error={formErrors.region}
              options={regions}
              handleChange={this.handleChangeRegion}
              required={true}
              fieldRef={this.selectRefs.region}
            />
            <FormDropdown
              type="text"
              label="Province"
              name="province"
              value={mcleProfile.province}
              error={formErrors.province}
              options={provinces}
              disabled={provinces.length === 0}
              handleChange={this.handleChangeProvince}
              required={true}
              fieldRef={this.selectRefs.province}
            />
            <FormDropdown
              type="text"
              label="City"
              name="city"
              value={mcleProfile.city}
              error={formErrors.city}
              options={cities}
              disabled={cities.length === 0}
              handleChange={this.handleChangeCity}
              required={true}
              fieldRef={this.selectRefs.city}
            />
            <FormDropdown
              type="text"
              label="Zip Code"
              name="zip_code"
              value={mcleProfile.zip_code}
              error={formErrors.zip_code}
              options={zipCodes}
              disabled={zipCodes.length === 0}
              handleChange={this.handleChangeZip}
              required={true}
              fieldRef={this.selectRefs.zip_code}
            />
            <FormInput
              type="text"
              label="Home Address"
              name="home_address"
              value={mcleProfile.home_address}
              error={formErrors.home_address}
              handleChange={this.handleChange}
              disabled={homeSameAsMailingAddress}
            />
            <CheckBox
              text="Same as Preferred Mailing Address?"
              value={homeSameAsMailingAddress}
              onClick={() => this.toggleCopyMailingAddress("home")}
              id="chk-same-mailing"
            />
            <FormInput
              type="text"
              label="Work Address"
              name="work_address"
              value={mcleProfile.work_address}
              error={formErrors.work_address}
              handleChange={this.handleChange}
              disabled={workSameAsMailingAddress}
            />
            <CheckBox
              text="Same as Preferred Mailing Address?"
              value={workSameAsMailingAddress}
              onClick={() => this.toggleCopyMailingAddress("work")}
              id="chk-same-home"
            />
            <div className="grid-section">Contact Details</div>
            <FormInput
              type="number"
              label="Telephone Number"
              name="telephone_number"
              value={mcleProfile.telephone_number}
              error={formErrors.telephone_number}
              handleChange={this.handleChange}
            />
            <FormInput
              type="number"
              label="Fax Number"
              name="fax_number"
              value={mcleProfile.fax_number}
              error={formErrors.fax_number}
              handleChange={this.handleChange}
            />
            <div className="grid-section">Other Details</div>
            <FormInput
              type="text"
              label="Place of Birth"
              name="birth_place"
              value={mcleProfile.birth_place}
              error={formErrors.birth_place}
              handleChange={this.handleChange}
            />
            <FormDropdown
              label={"Civil Status"}
              name={"civil_status"}
              value={mcleProfile.civil_status}
              options={civilStatus}
              handleChange={this.handleSelect}
              fieldRef={this.selectRefs.civil_status}
            />
            <div className="actions">
              <Button
                label="Save Information"
                size="large"
                onClick={() => this.validateFormOnSubmit()}
                loading={loading}
              />
            </div>
          </Panel>
          <StatementModal
            isOpen={showStatementModal}
            closeModal={() => this.statementModalToggle()}
            title="DATA PRIVACY STATEMENT AND CONSENT FORM"
            consentLabel="I am confirming that I have read and accept the privacy policy and agree to the collection of my personal information as outlined."
            message={schoolData.data_privacy + schoolData.consent_form}
            onConfirm={() => {
              this.statementModalToggle()
              this.handleSaveMCLE()
            }}
          />
        </div>
      </>
    )
  }
}

export default MCLEProfile
